import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import {
  GET_ENTITIES_BY_ENTITYTYPE,
  get_headers,
  get_project_id
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from "axios";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';

export default {
  name: "ManageTrustCompliance",
  mixins: [alert_mixin],
  components: {
    NavigationBackButton
  },
  data() {
    return {
      headers: get_headers(),
      project_id: get_project_id(),
      entity_type_id: "",
      entity_type_name: '',
      table_data: [],
      data_table: null,
      loading: false
    };
  },
  methods: {
    go_to_pending_compliance_checks(row) {
      this.$router.push({
        path: '/view_compliance_requirements',
        query: {
          entity_type_id: this.entity_type_id,
          entity_id: row['Application No'],  // or row.RawData.id
          entity_type_name: this.entity_type_name
        }
      });
    },
    
    fetch_entities_by_type() {
      this.loading = true;
      
      axios.get(GET_ENTITIES_BY_ENTITYTYPE, {
        params: { 
          project_id: this.project_id,
          entity_type_name: this.entity_type_name 
        },
        headers: this.headers
      })
      .then(response => {
        const response_data = response.data.data || {};
        const entities_list = response_data.list_pending_entities || [];
        this.table_data = entities_list.map(entity => ({
          'Application No': entity.id || 'N/A',
          'Email': entity.profile_role?.profile?.user?.email || 'N/A',
          'Date Created': entity.date_created || 'N/A',
          'Status': entity.status?.status || 'Pending Review',
          'RawData': entity
        }));
        
        this.init_data_table();
      })
      .catch(error => {
        this.show_error('Error fetching entities', error);
        this.table_data = [];
        this.init_data_table();
      })
      .finally(() => {
        this.loading = false;
      });
    },
    
    init_data_table() {
      this.$nextTick(() => {
        if (this.data_table) {
          this.data_table.destroy();
        }
        
        this.data_table = $(this.$el).find('#compliance_table').DataTable({
          responsive: true,
        });
      });
    }
  },
  mounted() {
    this.entity_type_id = this.$route.query.entity_type_id,
    this.entity_type_name = this.$route.query.entity_type_name || '';
    if (this.entity_type_name) {
      this.fetch_entities_by_type();
    } else {
      this.init_data_table();
    }
  },
  beforeDestroy() {
    if (this.data_table) {
      this.data_table.destroy();
    }
  }
};